exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1rkd- {\n  cursor: pointer;\n}\n", ""]);

// Exports
exports.locals = {
	"card": "_1rkd-"
};